export default {
  sizeSmall: "Low",
  sizeMedium: "Medium",
  sizeLarge: "Large",
};
